import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';
import ComprobantesConfigBody from './ComprobantesConfigBody';

const ComprobantesGastos = (props) => {
  const {
    comprobantes,
    empresaId,
    loading,
    onChangeValue,
    onLoad,
    configInicial,
    seleccionarTodos,
    deseleccionarTodos
  } = props;

  return (
    <ComprobantesConfigBody
      comprobantes={comprobantes}
      empresaId={empresaId}
      loading={loading}
      onChangeValue={onChangeValue}
      onLoad={onLoad}
      configInicial={configInicial}
      seleccionarTodos={seleccionarTodos}
      deseleccionarTodos={deseleccionarTodos}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    comprobantes: state.gastos.comprobantesGastos.comprobantes,
    loading: state.gastos.comprobantesGastos.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoad: (empresaId) => dispatch(actions.loadComprobantesGastos(empresaId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ComprobantesGastos);
